import { NodeType } from 'prosemirror-model'
import { type EditorView } from 'prosemirror-view'
import { turnIntoList as turnIntoListCommand } from '../Commands/lists/turnIntoList'

export const turnIntoList = (editorView: EditorView, type: NodeType, listAttrs?: any) => () => {
  turnIntoListCommand(type, listAttrs)(editorView.state, editorView.dispatch)
  editorView.focus()
}
